const AU_RESIDENCY_STATUS_TYPES = {
  australian_resident: {
    desc: 'Australian resident for tax purposes',
  },
  foreign_resident: {
    desc: 'Foreign resident',
  },
  working_holiday_maker: {
    desc: 'Working holiday maker',
  },
} as const;

export default AU_RESIDENCY_STATUS_TYPES;
